import React, { useState, useRef, useEffect, useCallback, useImperativeHandle, useContext, createContext } from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useProgressStore } from "./progress_store";

function Progress() {
  const isLoading = useProgressStore().isLoading;

  return (
    <div>
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0)",
          zIndex: theme.zIndex.modal + 11
        })}
        open={isLoading}
      >
        <div
          style={{
            position: "relative",
            display: "inline-flex",
            width: 130,
            height: 130,
            opacity: 1,
            backgroundColor: "#ffffff",
            borderRadius: "50%", 
            padding: "10px",       
          }}
        >
          {/* 회색 배경 원 */}
          <CircularProgress
            variant="determinate"
            value={100}
            size={90}
            thickness={4}
            sx={{
              color: "#d9d9d9",
              position: "absolute",
              top: 20,
              left: 20
            }}
          />

          {/* 실제 로딩 부분 */}
          <CircularProgress
            size={90}
            thickness={4}
            sx={{
              color: "#051766",
              position: "absolute",
              top: 20,
              left: 20,
              '& .MuiCircularProgress-circle': {
                strokeDasharray: '16, 200 !important',
                strokeLinecap: 'round',
              }
            }}
          />
        </div>
      </Backdrop>
    </div>
  );
}

export default React.memo(Progress);
